'use client'

import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const SvgAppleAppStoreIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 134 40",
    role: "img",
    ref,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx(
        "rect",
        {
          width: 133,
          height: 39,
          x: 0.5,
          y: 0.5,
          fill: "#000",
          stroke: "#CCC",
          rx: 5.5
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M27.994 20.682c-.03-3.2 2.62-4.756 2.74-4.828-1.5-2.187-3.824-2.485-4.641-2.51-1.953-.205-3.846 1.169-4.841 1.169-1.014 0-2.546-1.149-4.197-1.115-2.124.033-4.111 1.263-5.2 3.173-2.25 3.893-.573 9.616 1.582 12.763 1.078 1.542 2.338 3.263 3.987 3.202 1.613-.066 2.215-1.028 4.162-1.028 1.928 0 2.494 1.028 4.175.99 1.732-.028 2.821-1.549 3.862-3.104 1.245-1.767 1.745-3.507 1.765-3.596-.04-.014-3.362-1.282-3.394-5.116M24.817 11.274c.868-1.085 1.462-2.56 1.297-4.059-1.256.056-2.826.869-3.73 1.93-.8.935-1.515 2.468-1.33 3.909 1.41.105 2.858-.712 3.763-1.78"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M51.258 30.504h2.243L49.25 17.196h-2.613l-4.231 13.308h2.184l1.17-3.91h4.27zm-2.71-9.024 1.111 3.475H46.13l1.092-3.475q.43-1.658.624-2.507h.04q.486 1.974.662 2.507M63.076 29.457q1.306-1.42 1.306-3.87 0-2.19-1.122-3.534-1.12-1.342-2.798-1.342-2.145 0-3.198 1.718h-.04l-.117-1.521h-1.852q.078 1.62.078 3.159v10.347h2.106v-5.055h.04q.82 1.362 2.69 1.362 1.736 0 2.907-1.264m-1.463-6.101q.625.909.624 2.31 0 1.52-.664 2.449-.661.927-1.852.928-1.012 0-1.647-.721-.634-.721-.634-1.768v-1.6q0-.255.098-.65a2.43 2.43 0 0 1 .828-1.373 2.17 2.17 0 0 1 1.414-.523q1.149 0 1.833.948M73.975 29.457q1.308-1.42 1.308-3.87 0-2.19-1.12-3.534-1.123-1.342-2.799-1.342-2.147 0-3.198 1.718h-.04l-.117-1.521h-1.852q.077 1.62.078 3.159v10.347h2.106v-5.055h.04q.816 1.362 2.69 1.362 1.735 0 2.904-1.264m-1.462-6.101q.624.909.625 2.31 0 1.52-.664 2.449-.662.927-1.852.928-1.015 0-1.65-.721-.63-.721-.631-1.768v-1.6q0-.255.098-.65a2.43 2.43 0 0 1 .827-1.373 2.18 2.18 0 0 1 1.414-.523q1.15 0 1.833.948",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M87.47 26.772q0 1.698-1.167 2.764-1.283 1.165-3.58 1.165-2.12 0-3.406-.829l.487-1.777q1.388.85 3.044.85 1.189 0 1.854-.544.662-.544.662-1.454 0-.81-.546-1.364-.545-.553-1.814-1.029-3.45-1.304-3.45-3.816 0-1.642 1.21-2.689 1.205-1.048 3.217-1.048 1.794 0 2.983.632l-.526 1.738q-1.111-.612-2.516-.612-1.112 0-1.734.553-.527.493-.527 1.205-.001.79.604 1.303.525.474 1.912 1.027 1.694.691 2.496 1.618.798.925.798 2.307M94.433 22.508h-2.321v4.66q0 1.776 1.228 1.776.565 0 .936-.099l.058 1.62q-.623.234-1.638.235-1.247 0-1.95-.77t-.703-2.587v-4.837h-1.382v-1.6h1.382V19.15l2.069-.632v2.39h2.32z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M103.656 29.26q1.249-1.42 1.249-3.633 0-2.153-1.211-3.513-1.268-1.402-3.354-1.402-2.165 0-3.441 1.422-1.278 1.421-1.277 3.652 0 2.131 1.238 3.534 1.238 1.4 3.324 1.4 2.164.001 3.472-1.46m-1.501-5.841q.566.95.565 2.277-.001 1.326-.584 2.296-.683 1.167-1.89 1.168-1.23 0-1.912-1.148-.566-.948-.565-2.276-.001-1.367.565-2.317.661-1.148 1.931-1.148 1.227 0 1.89 1.148",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M111.749 22.783a3.6 3.6 0 0 0-.664-.06q-1.11 0-1.716.85-.527.75-.527 1.896v5.035h-2.104l.02-6.574q0-1.659-.079-3.021h1.834l.077 1.836h.058q.333-.948 1.053-1.52a2.53 2.53 0 0 1 1.522-.514q.291 0 .526.039z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M121.089 26.219a5 5 0 0 0 .077-.967q0-1.796-.835-3.02-1.053-1.54-3.102-1.54-2.087 0-3.314 1.54-1.171 1.441-1.171 3.613 0 2.211 1.257 3.524 1.258 1.313 3.463 1.313 1.831 0 3.177-.593l-.33-1.48q-1.152.454-2.556.454-1.268 0-2.066-.671-.88-.75-.917-2.173zm-2.339-3.16q.428.692.409 1.64v-.001h-4.387q.097-.966.624-1.658.642-.87 1.676-.87 1.13 0 1.678.89M46.929 13.667q1.044-.892 1.044-2.658 0-1.572-.966-2.416-.862-.747-2.557-.747-.959 0-1.783.136v6.431q.632.078 1.514.078 1.78 0 2.748-.824m-.645-4.385q.598.612.598 1.756-.001 1.281-.647 1.95-.646.67-1.834.67-.507 0-.699-.03V8.74q.345-.069.834-.068 1.15 0 1.748.611M53.145 13.822q.613-.698.613-1.785 0-1.056-.593-1.726-.624-.688-1.648-.688-1.063 0-1.69.698-.628.698-.627 1.794 0 1.047.607 1.736.609.69 1.633.689 1.063 0 1.705-.718m-.737-2.87q.276.467.277 1.119 0 .653-.287 1.128-.336.574-.928.574-.603 0-.94-.564-.276-.466-.277-1.119 0-.672.278-1.138.325-.564.949-.564.601 0 .928.564",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "m61.515 9.72-1.456 4.713h-.948l-.604-2.047a16 16 0 0 1-.374-1.523h-.019q-.135.777-.374 1.523l-.64 2.047h-.96L54.772 9.72h1.064l.526 2.241q.19.796.316 1.513h.019q.115-.592.384-1.503l.66-2.25h.843l.633 2.202q.23.805.373 1.552h.03q.105-.727.315-1.552L60.5 9.72zM66.879 14.433h-1.035v-2.7q0-1.248-.938-1.248a.93.93 0 0 0-.747.343q-.286.346-.287.808v2.796h-1.035v-3.366q0-.62-.038-1.349h.91l.048.737h.029q.181-.343.536-.569.421-.264.938-.265.652 0 1.083.427.536.524.536 1.562zM69.733 14.433h-1.034V7.556h1.034z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M75.211 13.822q.613-.698.613-1.785 0-1.056-.593-1.726-.624-.688-1.649-.688-1.061 0-1.69.698-.627.698-.626 1.794 0 1.047.607 1.736t1.633.689q1.063 0 1.705-.718m-.738-2.87q.276.467.277 1.119 0 .653-.287 1.128-.335.574-.927.574-.604 0-.94-.564-.276-.466-.277-1.119 0-.672.278-1.138.324-.564.949-.564.6 0 .927.564M79.903 14.433h.93a7.5 7.5 0 0 1-.068-1.124v-1.736q0-1.95-1.827-1.95-.947 0-1.596.407l.21.688q.525-.348 1.214-.349.966 0 .966.931v.088q-1.293-.01-2.007.446t-.714 1.319q0 .572.365.96.402.427 1.062.427.882 0 1.36-.65h.028zm-.145-2.347v.727a.9.9 0 0 1-.375.742 1.04 1.04 0 0 1-.633.218.72.72 0 0 1-.506-.184q-.199-.184-.198-.553 0-.98 1.712-.95M85.794 14.433h.918a20 20 0 0 1-.037-1.27V7.556H85.64v2.706h-.02q-.374-.64-1.311-.64-.853 0-1.437.66-.604.708-.603 1.853 0 1.067.555 1.736.556.67 1.398.67 1.053 0 1.495-.865h.028zm-.154-2.774v.786q.001.504-.298.863a1 1 0 0 1-.817.388 1.06 1.06 0 0 1-.905-.465q-.318-.435-.318-1.135.001-.727.332-1.193.333-.466.91-.466.403 0 .693.257a1.2 1.2 0 0 1 .403.965M94.948 13.822q.613-.698.613-1.785 0-1.056-.593-1.726-.623-.688-1.647-.688-1.064 0-1.691.698-.628.698-.627 1.794 0 1.047.607 1.736.61.69 1.633.689 1.064 0 1.705-.718m-.736-2.87q.276.467.277 1.119-.001.653-.287 1.128-.335.574-.93.574-.602 0-.938-.564-.278-.466-.278-1.119 0-.672.278-1.138.327-.564.948-.564.603 0 .93.564",
          clipRule: "evenodd"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          d: "M101.125 14.433h-1.034v-2.7q0-1.248-.939-1.248a.93.93 0 0 0-.746.343 1.22 1.22 0 0 0-.288.808v2.796h-1.035v-3.366q0-.62-.037-1.349h.909l.048.737h.029a1.5 1.5 0 0 1 .536-.569q.422-.264.939-.265.65 0 1.082.427.537.524.536 1.562zM108.089 10.504h-1.14v2.29q.001.873.604.873.278 0 .461-.05l.026.796q-.307.117-.803.117-.613 0-.957-.378-.346-.378-.346-1.271v-2.377h-.68v-.785h.68v-.864l1.014-.31v1.173h1.14v.786zM113.566 14.433h-1.035v-2.68q0-1.268-.937-1.268-.719 0-.988.735-.047.155-.048.377v2.835h-1.034V7.556h1.034v2.841h.02q.49-.775 1.398-.775.642 0 1.064.427.526.533.526 1.581z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#fff",
          fillRule: "evenodd",
          d: "M119.179 12.328q.037-.193.038-.475.001-.883-.415-1.483-.516-.756-1.521-.756-1.026 0-1.627.756-.576.708-.575 1.775-.001 1.086.617 1.731t1.699.645q.902 0 1.562-.29l-.162-.729a3.4 3.4 0 0 1-1.254.223q-.623 0-1.016-.33-.43-.368-.45-1.067zm-1.15-1.55q.212.338.201.804h-2.155a1.6 1.6 0 0 1 .307-.815.98.98 0 0 1 .824-.427q.555 0 .823.437",
          clipRule: "evenodd"
        }
      )
    ]
  }
);
const ForwardRef = forwardRef(SvgAppleAppStoreIcon);
ForwardRef.displayName = "AppleAppStoreIcon";

export { ForwardRef as default };
//# sourceMappingURL=AppleAppStoreIcon.mjs.map
